import { roleGuarded } from '@/components/shell/RoleState';
import { VoiceTab } from '@/features/ai/VoiceTab';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/ai/voice')({
  staticData: { roles: ['owner'] },
  component: roleGuarded(VoiceTab),
});
